import { HorizontalBasicBar } from '../../../Charts/Bar/Horizontal';

import { Box, Skeleton } from '@chakra-ui/react';
import PanelCard from '../../../PanelCard';
import {
  useGetAnalyticsCountByTeam,
  useGetAnalyticsCountByTeamExport,
} from 'views/main/organization/analytics-v3/hooks/useGetAnalyticsData';
import { AppTracker } from 'shared/analytics/tracker';
import { ANALYTIC_V3_EVENTS } from 'views/main/organization/analytics-v3/constants';
import Empty from 'views/main/organization/analytics-v3/icons/empty';
import Error from 'views/main/organization/analytics-v3/components/Error';
import { AxiosError } from 'axios';
export default function IncidentCountByTeam({
  isOrgAnalytics = false,
}: {
  isOrgAnalytics?: boolean;
}) {
  const {
    data,
    isLoading,
    isError,
    refetch: refetchCountByTeam,
    error,
  } = useGetAnalyticsCountByTeam();
  const { isLoading: isLoadingCountByTeam, refetch: refetchCountByTeamExport } =
    useGetAnalyticsCountByTeamExport();

  const handleExport = () => {
    AppTracker.track(
      ANALYTIC_V3_EVENTS.INCIDENT_ANALYTICS_CHART_EXPORT_CLICKED,
      {
        'Analytics Scope': isOrgAnalytics ? 'Organization Analytics' : 'Team Analytics',
        'Analytics Type': 'Incident Analytics',
        'Analytics Tab': 'Incident Analytics',
        'Chart Title': 'Incident Count by Team',
      },
      true,
    );
    refetchCountByTeamExport();
  };

  const handleLegendSelect = (name: string) => {
    AppTracker.track(
      ANALYTIC_V3_EVENTS.INCIDENT_ANALYTICS_CHART_LEVEL_FILTER_APPLIED,
      {
        'Analytics Scope': isOrgAnalytics ? 'Organization Analytics' : 'Team Analytics',
        'Analytics Type': 'Incident Analytics',
        'Analytics Tab': 'Incident Analytics',
        'Chart Title': 'Incident Count by Team',
        'Legend Name': name,
      },
      true,
    );
  };

  const isEmpty = data?.length === 0;

  return (
    <PanelCard
      title="Incident Count by Team"
      onExportClick={handleExport}
      chartDescription="TOP 10 TEAM"
    >
      <Box position="relative" height={616}>
        {isLoading ? (
          <Skeleton height={616} />
        ) : isEmpty ? (
          <Empty />
        ) : isError ? (
          <Error
            onRefreshClick={refetchCountByTeam}
            errorMessage={(error as AxiosError).response?.data?.message}
          />
        ) : (
          <HorizontalBasicBar data={data || []} onLegendSelect={handleLegendSelect} />
        )}
      </Box>
    </PanelCard>
  );
}
